import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data1 from "../../Data/admissionsCommittee/admissionsCommitteeData.json";
import data2 from "../../Data/admissionsCommittee/admissionsCommitteeDataRating.json";
import data3 from "../../Data/admissionsCommittee/admissionsCommitteeDataDoc.json";

export default function AdmissionsCommittee() {
  useSEO(seoConfig.admissionsCommittee);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Приемная комиссия
      </h1>

      <h3 className="about-nii__title antiCorruption__title">
        ГБУ СО "УрНИИДВиИ" объявляет (на конкурсной основе) набор желающих
        обучаться по программам подготовки кадров высшей квалификации в
        ординатуре в (срок обучения 2 года) по специальности 31.08.32
        Дерматовенерология.
      </h3>

      <Accordion data={data2} />

      <Accordion data={data1} />

      <p className="dissertation__text">
        Обращаем внимание, что зачисление в ординатуру осуществляется с
        оригиналами документов о высшем образовании
      </p>

      <Accordion data={data3} />
    </section>
  );
}
